import { ModuleItem } from '@core/config';
import { environment } from 'environments/environment';

const isSit = ['dev', 'sit'].indexOf(environment.environment) !== -1;
const suffix = isSit ? '-sit' : '';

export const modules: ModuleItem[] = [
  {
    title: 'CORE.MODULE.mobile_worker',
    svgIcon: 'mw-icon-module-mobile-worker',
    url: `https://app${suffix}.mworker.com`,
    autoLogin: true,
  },
  {
    title: 'CORE.MODULE.asset_tracking',
    svgIcon: 'mw-icon-module-asset-tracking',
    url: 'https://viatracks.devinco.com/asset',
  },
  {
    title: 'CORE.MODULE.trip_log',
    svgIcon: 'mw-icon-module-trip-log',
    url: 'https://viatracks.devinco.com/trips',
  },
  {
    title: 'CORE.MODULE.mw-transport',
    svgIcon: 'mw-icon-module-transport',
    url: `https://transport${suffix}.mworker.com`,
    autoLogin: true,
  },
];
